import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import useMerchantStore from 'store/merchant'

const useTransactions = () => {
  const { traderId: merchantTraderId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams() ?? undefined;
  const queryStartDate = searchParams.get('startDate') ?? undefined;
  const queryEndDate = searchParams.get('endDate') ?? undefined;
  const queryTransactionTypeId = searchParams.get('transactionTypeId') ?? undefined;
  const queryDeviceId = searchParams.get('deviceId') ?? undefined;

  const merchantTransaction = useMerchantStore(
    (state) => state.merchantTransaction
  )
  const merchantTransactionLoading = useMerchantStore(
    (state) => state.merchantTransactionLoading
  )
  const getMerchantTransactionFiltered = useMerchantStore(
    (state) => state.getMerchantTransactionFiltered
  )

  useEffect(() => {
    if (merchantTraderId) {
      getMerchantTransactionFiltered(Number(merchantTraderId), {
        startDate: queryStartDate,
        endDate: queryEndDate,
        transactionTypeId: Number(queryTransactionTypeId),
        deviceId: Number(queryDeviceId),
      })
    }
  }, [merchantTraderId, queryStartDate, queryEndDate, queryTransactionTypeId, queryDeviceId, getMerchantTransactionFiltered])

  return {
    merchantTransaction,
    merchantTransactionLoading,
  }
}

export default useTransactions
